import React, { useEffect, createContext, useState } from 'react';
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import jwtWorker from "utils/jwt-worker";
import utils from 'utils';

export const SocketContext = createContext();

const SOCKET = Stomp.over(new SockJS(process.env.REACT_APP_SOCKET_URL));
const headers = { Authorization: jwtWorker.getTokenFromStorage(), "x-expires": 180000 }

export const WebSocketContext = (props) => {

    const [stompClient, setStompClient] = useState(SOCKET);
    const [socketError, setSocketError] = useState({ error: false, message: null });

    // stompClient.heartbeat.outgoing = 2000;
    // stompClient.heartbeat.incoming = 0;

    useEffect(() => {
        stompClient.connect(headers, () => {
            setStompClient(stompClient);
        }, error => {
            handleSocketError(error);
        });
        return () => (stompClient && stompClient.connected) && stompClient.disconnect();
    }, []);

    //SENDING MESSAGE
    const sendMessage = ({ destination, payload }) => {
        try {
            stompClient.send(destination, { Authorization: jwtWorker.getTokenFromStorage() }, JSON.stringify(payload));
        } catch (error) {
            alert(error);
        }
    }

    //PROMISING STOMP SOCKET CLIENT
    const getStompClient = () => new Promise((resolve, reject) => {
        const interId = window.setInterval(() => {
            if (stompClient && stompClient.connected) {
                resolve(stompClient);
                clearInterval(interId);
            }
        }, 1);
    });

    //ERROR ALERT TEMPLATE ON WEBSOCKET LOSE CONNECTION
    const ConnectionErrorAlert = () => {
        useEffect(() => {
            utils.fixErrorAlertOverlaping();
        }, []);
        return (
            <div className="error-socket-boundary w-100 alert-danger text-center" style={{ position: "fixed", top: 0, height: "2rem" }}>
                <strong className="text-danger">{socketError.message}</strong> <a href="/" onClick={(e) => { e.preventDefault(); window.location.reload(false); }}>Click to refresh</a>
            </div>
        );
    }

    const handleSocketError = (error) => {
        Object.keys(stompClient.subscriptions).length ? window.location.reload(false) : setSocketError({ error: true, message: error.toString() });
    }

    return (
        <SocketContext.Provider value={{ sendMessage, stompClient, setStompClient, getStompClient }}>
            {props.children}
            {socketError.error && <ConnectionErrorAlert />}
        </SocketContext.Provider>

    );
}

